import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { hoursToMilliseconds, minutesToMilliseconds } from "date-fns";

export function getContext() {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: minutesToMilliseconds(5),
                gcTime: hoursToMilliseconds(4),
            },
        },
    });

    return {
        queryClient,
    };
}

export function Provider({
    children,
    queryClient,
}: {
    children: React.ReactNode;
    queryClient: QueryClient;
}) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
